import useAppStore from "@/store/use-app-store";
import { TextFields, Textsms } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Timer } from "components/Timer";
import { getMessageBySignUuid } from "components/gql/gql-functions";
import { GetMessageQuery } from "components/gql/queris/GetMessage";
import { isIdentical, isObjectEmpty } from "data/functions";
import React, { useEffect, useState } from "react";

function Message({ onChange, setCompanyUuid, setDataUuid }) {
  const { isMobile, message, token } = useAppStore();
  const [msg, setMsg] = useState(message?.text || "");

  const [getMessageQuery] = GetMessageQuery();

  function onMessageChange(event) {
    setMsg(event.target.value);
    onChange(event.target.value);
  }

  useEffect(() => {
    onChange(msg);
  }, [msg]);

  useEffect(() => {
    if (!message) return;

    if (message?.text && !isIdentical(message, message?.text)) {
      setMsg(message?.text);
    }
    message?.data_uuid && setDataUuid(message?.data_uuid);
    message?.company_uuid && setCompanyUuid(message?.company_uuid);
  }, [message]);

  useEffect(() => {
    if (!message || !token) return;

    if (message?.sign_data_uuid) {
      getMessageBySignUuid(getMessageQuery);
    }
  }, [message, token]);

  return (
    <>
      <Typography sx={{ margin: "6px 0" }} variant="h6">
        Подписываемое сообщение
      </Typography>
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Textsms />
            </InputAdornment>
          ),
          style: {
            fontSize: isMobile ? "0.875rem" : "1rem",
          },
        }}
        // disabled={isObjectEmpty(message?.text) ? false : true}
        fullWidth
        // label="Подписываемое сообщение"
        // maxRows={dataObj?.deviceWidth?.isMobile ? 4 : undefined}
        mb={2}
        mt={2}
        multiline
        name="message"
        onChange={(e) => onMessageChange(e)}
        // rows={dataObj?.deviceWidth?.isMobile ? undefined : 4}
        // sx={{ margin: "0.875rem 0" }}
        type="text"
        value={msg || ""}
        // variant={dataObj?.deviceWidth?.isMobile ? "standard" : "outlined"}
        variant="standard"
      />
    </>
  );
}

export default Message;
